export var DominoBuilderErrorType;
(function (DominoBuilderErrorType) {
    DominoBuilderErrorType["BlueprintReferenceError"] = "BlueprintReferenceError";
    DominoBuilderErrorType["InvalidArgumentFormat"] = "InvalidArgumentFormat";
    DominoBuilderErrorType["InvalidArrayArgument"] = "InvalidArrayArgument";
    DominoBuilderErrorType["InvalidSymbolReference"] = "InvalidSymbolReference";
    DominoBuilderErrorType["MissingArgument"] = "MissingArgument";
    DominoBuilderErrorType["MissingPropertyWarning"] = "MissingPropertyWarning";
    DominoBuilderErrorType["MissingNameWarning"] = "MissingNameWarning";
    DominoBuilderErrorType["ParseError"] = "ParseError";
    DominoBuilderErrorType["ResourceFetchFailure"] = "ResourceFetchFailure";
    DominoBuilderErrorType["ResourceNotFound"] = "ResourceNotFound";
    DominoBuilderErrorType["SymbolReferencedBeforeDeclaration"] = "SymbolReferencedBeforeDeclaration";
    DominoBuilderErrorType["TypeError"] = "TypeError";
    DominoBuilderErrorType["UnusedArgument"] = "UnusedArgument";
})(DominoBuilderErrorType || (DominoBuilderErrorType = {}));
export var DominoBuilderErrorSeverity;
(function (DominoBuilderErrorSeverity) {
    DominoBuilderErrorSeverity["INFO"] = "INFO";
    DominoBuilderErrorSeverity["WARNING"] = "WARNING";
    DominoBuilderErrorSeverity["ERROR"] = "ERROR";
    DominoBuilderErrorSeverity["FATAL"] = "FATAL";
})(DominoBuilderErrorSeverity || (DominoBuilderErrorSeverity = {}));
export const DominoBuilderErrorSeverityOrdering = {
    [DominoBuilderErrorSeverity.INFO]: 0,
    [DominoBuilderErrorSeverity.WARNING]: 1,
    [DominoBuilderErrorSeverity.ERROR]: 2,
    [DominoBuilderErrorSeverity.FATAL]: 3,
};
export var DominoBuilderErrorScope;
(function (DominoBuilderErrorScope) {
    DominoBuilderErrorScope["RUNTIME"] = "RUNTIME";
    DominoBuilderErrorScope["DESIGN"] = "DESIGN";
})(DominoBuilderErrorScope || (DominoBuilderErrorScope = {}));
export const DominoBuilderErrorScopeOrdering = {
    [DominoBuilderErrorScope.RUNTIME]: 0,
    [DominoBuilderErrorScope.DESIGN]: 1,
};
export const errorSeverityFilter = (severity, e) => {
    return (!severity ||
        DominoBuilderErrorSeverityOrdering[e.severity] >=
            DominoBuilderErrorSeverityOrdering[severity]);
};
export const errorScopeFilter = (scope, e) => {
    return (!scope ||
        DominoBuilderErrorScopeOrdering[e.scope] >= DominoBuilderErrorScopeOrdering[scope]);
};
export const filterErrors = (scope, severity, errors) => {
    var _a;
    return ((_a = errors === null || errors === void 0 ? void 0 : errors.filter(e => errorScopeFilter(scope, e)).filter(e => errorSeverityFilter(severity, e))) !== null && _a !== void 0 ? _a : []);
};
export class DominoBuilderError extends Error {
    constructor(name, scope, severity, message, errorStack) {
        super(message);
        this.name = name;
        this.scope = scope;
        this.severity = severity;
        this.errorStack = errorStack;
    }
}
export function getErrorAggregateCallback(output, k) {
    if ((output === null || output === void 0 ? void 0 : output.hasOwnProperty(k)) && Array.isArray(output[k])) {
        return (scope, severity) => {
            var _a;
            return (_a = output[k].reduce((a, c) => { var _a, _b; return a.concat((_b = (_a = c === null || c === void 0 ? void 0 : c.getErrorAggregate) === null || _a === void 0 ? void 0 : _a.call(c, scope, severity)) !== null && _b !== void 0 ? _b : []); }, [])) !== null && _a !== void 0 ? _a : [];
        };
    }
    else {
        return (scope, severity) => { var _a, _b, _c; return (_c = (_b = (_a = output[k]) === null || _a === void 0 ? void 0 : _a.getErrorAggregate) === null || _b === void 0 ? void 0 : _b.call(_a, scope, severity)) !== null && _c !== void 0 ? _c : []; };
    }
}
//# sourceMappingURL=errors.js.map